export const MY_INFO_REQUEST = 'MY_INFO_REQUEST';
export const SET_MY_INFO = 'SET_MY_INFO';
export const MY_PASSWORD_CHANGE = 'MY_PASSWORD_CHANGE';
export const MY_TWOFACTOR_REMOVE = 'MY_TWOFACTOR_REMOVE';
export const MY_NAME_CHANGE = 'MY_NAME_CHANGE';
